import { Navbar } from "../Navbar"

export const BrowseLayout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />

            <main className="flex-1 pt-24 pb-16">
                <div className="container px-4 mx-auto">
                    {/* Page Header */}
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold mb-2">Browse Lisitngs</h1>
                        <p className="text-muted-foreground">
                            Discover fresh, homegrown food in your community.
                        </p>
                    </div>

                    {children}
                </div>
            </main>

            <footer className="bg-igbanwo-mint/5 p-8 border-t border-border/60">
                <div className="container px-4 mx-auto text-center text-sm text-muted-foreground">
                    &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
                </div>
            </footer>
        </div>
    )
}